// @ts-nocheck
import { catchAsync } from '../utils/api';
import axios from '../utils/axios';
import { ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT } from '../config';

const confirmWithdraw = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/confirm`, params);

    return result.data;
});

const manualConfirmWithdraw = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/manual-confirm`, params);

    return result.data;
});

const declineWithdraw = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/decline`, params);

    return result.data;
});

const holdTransaction = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/hold-status`, params);

    return result.data;
});

const cancelTransaction = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/cancel`, params);

    return result.data;
});

const manualCancelTransaction = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/orders/manual-cancel`, params);

    return result.data;
});

const createWithdrawalAutoprocessingRule = catchAsync(async ruleset => {
    const result = await axios.post(
        `${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/withdraw-auto-processing-rule`,
        ruleset,
    );

    return result.data;
});

const updateWithdrawalAutoprocessingRule = catchAsync(async (rulesetId, ruleset) => {
    const result = await axios.put(
        `${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/withdraw-auto-processing-rule/${rulesetId}`,
        ruleset,
    );

    return result.data;
});

const deleteWithdrawalAutoprocessingRule = catchAsync(async rulesetId => {
    const result = await axios.delete(
        `${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/withdraw-auto-processing-rule/${rulesetId}`,
    );

    return result.data;
});

const getWithdrawalAutoprocessingRuleList = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/withdraw-auto-processing-rule`);

    return result.data;
});

const getWithdrawalAutoprocessingRule = catchAsync(async id => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/withdraw-auto-processing-rule/${id}`);

    return result.data;
});

const blockUserPayment = catchAsync(async params => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/accounts/payment-block`, params);

    return result.data;
});

const getPaymentMethodsList = catchAsync(async () => {
    const result = await axios.get(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/payment-methods`);

    return result.data;
});

const createPaymentMethod = catchAsync(async data => {
    const result = await axios.post(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/payment-methods`, data);

    return result.data;
});

const updatePaymentMethodStatus = catchAsync(async ({ id, ...data }) => {
    const result = await axios.patch(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/payment-methods/${id}`, data);

    return result.data;
});

const updatePaymentMethodGlobalStatus = catchAsync(async (data) => {
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/payment-methods/global`, data);

    return result.data;
});

const updatePlatformStatus = catchAsync(async params => {
    const { id, platforms, comment } = params;
    const result = await axios.put(`${ONLINE_BACK_OFFICE_SERVICE_API_ENDPOINT}/payment-methods/${id}/platforms`, {
        platforms,
        comment,
    });

    return result.data;
});

const PaymentService = {
    declineWithdraw,
    confirmWithdraw,
    holdTransaction,
    cancelTransaction,
    manualCancelTransaction,
    manualConfirmWithdraw,
    createWithdrawalAutoprocessingRule,
    updateWithdrawalAutoprocessingRule,
    deleteWithdrawalAutoprocessingRule,
    getWithdrawalAutoprocessingRuleList,
    getWithdrawalAutoprocessingRule,
    blockUserPayment,
    getPaymentMethodsList,
    createPaymentMethod,
    updatePaymentMethodStatus,
    updatePaymentMethodGlobalStatus,
    updatePlatformStatus,
};

export default PaymentService;
